<admin-layout pageTitle="Auditoria de ajustes">
    <section class="audit">
        <header class="audit-head">
            <h1>Ajustes de ordenha</h1>
            <p class="hint">Quem alterou o quê nas ordenhas: busque por produtor, usuário, animal ou período.</p>
        </header>

        <form class="filters" (ngSubmit)="search()">
            <label>Produtor
                <input type="search" name="producer" [(ngModel)]="filters.producer" placeholder="Nome ou código APC" maxlength="60">
            </label>
            <label>Usuário
                <input type="search" name="actor" [(ngModel)]="filters.actor" placeholder="Login de quem alterou" maxlength="60">
            </label>
            <label>Animal
                <input type="search" name="animal" [(ngModel)]="filters.animal" placeholder="Nome do animal" maxlength="60">
            </label>
            <label>Ação
                <select name="action" [(ngModel)]="filters.action">
                    <option value="">Todas</option>
                    @for (a of actionOptions; track a.value) {
                        <option [value]="a.value">{{ a.label }}</option>
                    }
                </select>
            </label>
            <label>Resultado
                <select name="outcome" [(ngModel)]="filters.outcome">
                    <option value="">Todos</option>
                    @for (o of outcomeOptions; track o.value) {
                        <option [value]="o.value">{{ o.label }}</option>
                    }
                </select>
            </label>
            <label>De
                <input type="date" name="from" [(ngModel)]="filters.from" [max]="filters.to || null">
            </label>
            <label>Até
                <input type="date" name="to" [(ngModel)]="filters.to" [min]="filters.from || null">
            </label>
            <label class="check">
                <input type="checkbox" name="resubmitted" [(ngModel)]="filters.resubmitted">
                Só reenviados ao SRG-SCL
            </label>
            <div class="filter-actions">
                <button mat-flat-button color="primary" type="submit" [disabled]="state === 'loading'">
                    <mat-icon>search</mat-icon> Buscar
                </button>
                @if (activeCount > 0) {
                    <button mat-button type="button" (click)="clear()" [disabled]="state === 'loading'">Limpar ({{ activeCount }})</button>
                }
            </div>
        </form>

        @switch (state) {
            @case ('loading') {
                <div class="state" role="status"><mat-spinner diameter="32"></mat-spinner><span>Carregando…</span></div>
            }
            @case ('error') {
                <div class="state" role="alert">
                    <mat-icon>cloud_off</mat-icon>
                    <span>Não foi possível carregar a auditoria.</span>
                    <button mat-stroked-button type="button" (click)="load(page)">Tentar de novo</button>
                </div>
            }
            @default {
                @if (items.length === 0) {
                    <div class="state">
                        <mat-icon>manage_search</mat-icon>
                        <span>{{ activeCount > 0 ? 'Nenhum ajuste encontrado com esses filtros.' : 'Nenhum ajuste registrado ainda.' }}</span>
                        @if (activeCount > 0) {
                            <button mat-stroked-button type="button" (click)="clear()">Limpar filtros</button>
                        }
                    </div>
                } @else {
                    <ul class="log-list">
                        @for (l of items; track l.id) {
                            @let o = outcomeOf(l.outcome);
                            <li class="log" [class.failed]="l.outcome === 'FAILED'">
                                <div class="log-main">
                                    <div class="when">
                                        <span>{{ l.created | date: 'dd/MM/yyyy' }}</span>
                                        <small>{{ l.created | date: 'HH:mm:ss' }}</small>
                                    </div>
                                    <div class="what">
                                        <strong>{{ summary(l) }}</strong>
                                        <span class="reason" [class.muted]="!l.reason">{{ l.reason ? '“' + l.reason + '”' : 'Sem motivo informado' }}</span>
                                    </div>
                                    <div class="who">
                                        <span>{{ l.actorName || l.actorLogin || 'Usuário desconhecido' }}</span>
                                        <small>
                                            @if (actorTypeLabel(l.actorType)) { <span class="tag">{{ actorTypeLabel(l.actorType) }}</span> }
                                            @if (l.actorName && l.actorLogin) { {{ l.actorLogin }} }
                                        </small>
                                    </div>
                                    <div class="where">
                                        <span>{{ l.producerName || 'Produtor ' + (l.producerId || '-') }}</span>
                                        <small>
                                            @if (l.producerCode) { Cód. {{ l.producerCode }} · }
                                            @if (l.controlStartedAt) {
                                                Controle de {{ l.controlStartedAt | date: 'dd/MM/yyyy' }} ({{ controlStatusLabel(l.controlStatus) }})
                                            } @else if (l.controlId) {
                                                Controle {{ l.controlId }}
                                            }
                                        </small>
                                    </div>
                                    <div class="result">
                                        <span class="outcome" [class]="'outcome ' + l.outcome"><mat-icon>{{ o.icon }}</mat-icon>{{ o.label }}</span>
                                        @if (l.resubmitted) { <small><mat-icon>sync</mat-icon>Reenviado ao SRG-SCL</small> }
                                    </div>
                                    <button mat-button type="button" class="toggle" (click)="toggle(l.id)" [attr.aria-expanded]="expanded.has(l.id)">
                                        {{ expanded.has(l.id) ? 'Ocultar' : 'Detalhes' }}
                                        <mat-icon>{{ expanded.has(l.id) ? 'expand_less' : 'expand_more' }}</mat-icon>
                                    </button>
                                </div>
                                @if (expanded.has(l.id)) {
                                    <div class="log-details">
                                        @if (l.error) { <div class="err" role="alert"><mat-icon>error</mat-icon>{{ l.error }}</div> }
                                        <div class="cols">
                                            @for (s of sections(l); track s.title) {
                                                <div>
                                                    <strong>{{ s.title }}</strong>
                                                    <dl>
                                                        @for (e of s.rows; track e.label) { <dt>{{ e.label }}</dt><dd>{{ e.value }}</dd> }
                                                        @empty { <dd class="muted">Sem dados</dd> }
                                                    </dl>
                                                </div>
                                            }
                                        </div>
                                        <details>
                                            <summary>Dados técnicos</summary>
                                            <div class="ids">
                                                Ajuste {{ l.id }} · Produtor {{ l.producerId || '-' }} · Controle {{ l.controlId || '-' }} · Ordenha {{ l.milkingId || '-' }} · Animal {{ l.animalId || '-' }}
                                            </div>
                                            <div class="cols">
                                                <pre>{{ json(l.before) }}</pre>
                                                <pre>{{ json(l.after) }}</pre>
                                            </div>
                                        </details>
                                    </div>
                                }
                            </li>
                        }
                    </ul>
                    <div class="pager">
                        <button mat-stroked-button type="button" [disabled]="page === 0" (click)="load(page - 1)">Anterior</button>
                        <span>Página {{ page + 1 }}</span>
                        <button mat-stroked-button type="button" [disabled]="!hasMore" (click)="load(page + 1)">Próxima</button>
                    </div>
                }
            }
        }
    </section>
</admin-layout>
